// src/components/EditModalChamp.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Select, DatePicker, Button } from 'antd';
//import dayjs from 'dayjs';

const EditModalChamp = ({
  isEditModalOpen,
  editingEquipment,
  handleEditCancel,
  handleEditOk,
  form,
  handleValuesChange,
  isSaveDisabled,
  userRole,
  handleDeleteEquipment,
  manualStatusOptions,
}) => {
  // Локальный стейт для ручного статуса
  const [currentStatus, setCurrentStatus] = useState('Нет');

  // Состояние, указывающее какие даты отключить (при "Н/У")
  const [disabledDates, setDisabledDates] = useState({
    to1: false,
    to2: false,
    to3: false,
    majorRepair: false,
    verification: false,
    calibration: false,
    testing: false,
  });

  // ------------------- useEffect -------------------
  useEffect(() => {
    if (editingEquipment) {
      // 1. Заполняем форму
      form.setFieldsValue(editingEquipment);
      
      // 2. Если manualStatus не указан, ставим "Нет"
      const ms = editingEquipment.manualStatus || 'Нет';
      setCurrentStatus(ms);

      // 3. Настраиваем отключение дат
      setDisabledDates({
        to1: editingEquipment.to1Frequency === 'Н/У',
        to2: editingEquipment.to2Frequency === 'Н/У',
        to3: editingEquipment.to3Frequency === 'Н/У',
        majorRepair: editingEquipment.majorRepairFrequency === 'Н/У',
        verification: editingEquipment.verificationFrequency === 'Н/У',
        calibration: editingEquipment.calibrationFrequency === 'Н/У',
        testing: editingEquipment.testingFrequency === 'Н/У',
      });
    }
  }, [editingEquipment, form]);

  // ------------------- onValuesChange -------------------
  const onValuesChange = (changedValues, allValues) => {
    // Если пользователь изменил manualStatus
    if ('manualStatus' in changedValues) {
      const newStatus = changedValues.manualStatus || 'Нет';
      setCurrentStatus(newStatus);

      // Если вернули "Нет", сбрасываем comment
      if (newStatus === 'Нет') {
        form.resetFields(['comment']);
      }
    }

    // Проверка периодичности
    [
      'to1Frequency',
      'to2Frequency',
      'to3Frequency',
      'majorRepairFrequency',
      'verificationFrequency',
      'calibrationFrequency',
      'testingFrequency',
    ].forEach((freqField) => {
      if (freqField in changedValues) {
        const isDisabled = changedValues[freqField] === 'Н/У';
        const dateField = freqField.replace('Frequency', '');
        setDisabledDates((prev) => ({
          ...prev,
          [dateField]: isDisabled,
        }));
        if (isDisabled) {
          form.setFieldValue(dateField, null);
        }
      }
    });

    // Вызываем внешний колбэк (например, чтобы включить кнопку "Сохранить")
    handleValuesChange(changedValues, allValues);
  };

  return (
    <Modal
      title="Редактирование оборудования"
      open={isEditModalOpen}
      onCancel={handleEditCancel}
      footer={null}
      destroyOnClose
    >
      {editingEquipment && (
        <Form
          form={form}
          onFinish={handleEditOk}
          onValuesChange={onValuesChange}
        >
          <Form.Item label="Наименование" name="name">
            <Input />
          </Form.Item>

          <Form.Item label="Производитель" name="manufacturer">
            <Input />
          </Form.Item>

          <Form.Item label="Серийный номер" name="serialNumber">
            <Input />
          </Form.Item>

          <Form.Item label="Ссылка на QR-код" name="qrLink">
            <Input />
          </Form.Item>

          <Form.Item label="Ссылка на мануал" name="manualLink">
            <Input />
          </Form.Item>

          <Form.Item label="Локация" name="location">
            <Select
              options={[
                { label: 'Завод Таптатты', value: 'Завод Таптатты' },
                { label: 'Завод Ондырыс', value: 'Завод Ондырыс' },
                { label: 'Магазин Таптатты', value: 'Магазин Таптатты' },
              ]}
              placeholder="Выберите локацию"
              allowClear
            />
          </Form.Item>

          {/* ---------- Периодичность ТО1 ---------- */}
          <Form.Item label="Периодичность ТО 1" name="to1Frequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="ТО 1" name="to1">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to1} />
          </Form.Item>

          {/* ---------- Периодичность ТО2 ---------- */}
          <Form.Item label="Периодичность ТО 2" name="to2Frequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="ТО 2" name="to2">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to2} />
          </Form.Item>

          {/* ---------- Периодичность ТО3 ---------- */}
          <Form.Item label="Периодичность ТО 3" name="to3Frequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="ТО 3" name="to3">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.to3} />
          </Form.Item>

          {/* ---------- Периодичность Кап ремонта ---------- */}
          <Form.Item label="Периодичность Кап ремонта" name="majorRepairFrequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Кап ремонт" name="majorRepair">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.majorRepair} />
          </Form.Item>

          {/* ---------- Поверка ---------- */}
          <Form.Item label="Периодичность Поверки" name="verificationFrequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Поверка" name="verification">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.verification} />
          </Form.Item>

          {/* ---------- Калибровка ---------- */}
          <Form.Item label="Периодичность Калибровки" name="calibrationFrequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Калибровка" name="calibration">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.calibration} />
          </Form.Item>

          {/* ---------- Испытания ---------- */}
          <Form.Item label="Периодичность Испытаний" name="testingFrequency">
            <Select>
              <Select.Option value="Н/У">Не указано</Select.Option>
              <Select.Option value="monthly">Раз в месяц</Select.Option>
              <Select.Option value="quarterly">Раз в квартал</Select.Option>
              <Select.Option value="semi_annually">Раз в полгода</Select.Option>
              <Select.Option value="annually">Раз в год</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item label="Испытания" name="testing">
            <DatePicker format="YYYY-MM-DD" disabled={disabledDates.testing} />
          </Form.Item>

          {/* ---------- Ручной статус ---------- */}
          <Form.Item label="Ручной статус" name="manualStatus">
            <Select
              options={manualStatusOptions}
              placeholder="Выберите ручной статус или оставьте пустым"
              allowClear
            />
          </Form.Item>

          {/* ---------- Поле «Комментарий» (локальный стейт) ---------- */}
          {currentStatus !== 'Нет' && (
            <Form.Item
              label="Комментарий"
              name="comment"
              rules={[{ required: true, message: 'Пожалуйста, введите комментарий' }]}
            >
              <Input.TextArea rows={3} placeholder="Введите комментарий" />
            </Form.Item>
          )}

          {/* ---------- Кнопки ---------- */}
          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={isSaveDisabled}>
              Сохранить
            </Button>
            {userRole !== 'main_engineer' && (
              <Button
                danger
                onClick={() => handleDeleteEquipment(editingEquipment.id)}
                style={{ marginLeft: 8 }}
              >
                Удалить
              </Button>
            )}
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default EditModalChamp;
